import React, { createContext, useState } from "react";

export const CategoryContext = createContext(undefined);

// This context provider is passed to any component requiring the context
export const CategoryContextProvider = ({ children }) => {
  let [listReloadCounter, setListReloadCounter] = React.useState(0);
  let [editingItem, setEditingItem] = React.useState(null);
  let [categoryTypeList, setCategoryTypeList] = React.useState([]);
  let [associatedDetails, setAssociatedDetails] = useState({});
  const [categoryType, setCategoryType] = useState(null);
  const [reloadComp, setReloadComp] = useState(0);
  let [deleteinfo, setDeleteInfo] = useState({
    status: null,
    message: "",
  });

  return (
    <CategoryContext.Provider
      value={{
        listReloadCounter,
        setListReloadCounter,
        editingItem,
        setEditingItem,
        categoryTypeList,
        setCategoryTypeList,
        associatedDetails,
        setAssociatedDetails,
        setDeleteInfo,
        deleteinfo,
        reloadComp,
        setReloadComp,
        categoryType,
        setCategoryType,
      }}
    >
      {children}
    </CategoryContext.Provider>
  );
};